export const FETCH_CORRESPONDENT_ENTITY_DETAILS = 'src/Correspondent/Create/action/Fetch_Correspondent_Entity_Details';
export const FETCH_CORRESPONDENT_ENTITY_DETAILS_SUCCESS = 'src/Correspondent/Create/action/Fetch_Correspondent_Entity_Details_Success';
export const FETCH_CORRESPONDENT_ENTITY_DETAILS_FAILURE = 'src/Correspondent/Create/action/Fetch_Correspondent_Entity_Details_Failure';
export const fetchCorrespondentEntityDetails = (data) => {
    return {
        type: FETCH_CORRESPONDENT_ENTITY_DETAILS,
        data
    }
}
export const fetchCorrespondentEntityDetailsSuccess = (data) => {
    return {
        type: FETCH_CORRESPONDENT_ENTITY_DETAILS_SUCCESS,
        data
    }
}
export const fetchCorrespondentEntityDetailsFailure = (data) => {
    return {
        type: FETCH_CORRESPONDENT_ENTITY_DETAILS_FAILURE,
        data
    }
}

export const CREATE_CORRESPONDENT_ENTITY = 'src/Correspondent/Create/action/Create_Correspondent_Entity';
export const CREATE_CORRESPONDENT_ENTITY_SUCCESS = 'src/Correspondent/Create/action/Create_Correspondent_Entity_Success';
export const CREATE_CORRESPONDENT_ENTITY_FAILURE = 'src/Correspondent/Create/action/Create_Correspondent_Entity_Failure';
export const createCorrespondentEntity = (data) => {
    return {
        type: CREATE_CORRESPONDENT_ENTITY,
        data
    }
}
export const createCorrespondentEntitySuccess = (data) => {
    return {
        type: CREATE_CORRESPONDENT_ENTITY_SUCCESS,
        data
    }
}
export const createCorrespondentEntityFailure = (data) => {
    return {
        type: CREATE_CORRESPONDENT_ENTITY_FAILURE,
        data
    }
}

export const EDIT_CORRESPONDENT_ENTITY = 'src/Correspondent/Create/action/Edit_Correspondent_Entity';
export const EDIT_CORRESPONDENT_ENTITY_SUCCESS = 'src/Correspondent/Create/action/Edit_Correspondent_Entity_Success';
export const EDIT_CORRESPONDENT_ENTITY_FAILURE = 'src/Correspondent/Create/action/Edit_Correspondent_Entity_Failure';
export const editCorrespondentEntity = (data) => {
    return {
        type: EDIT_CORRESPONDENT_ENTITY,
        data
    }
}
export const editCorrespondentEntitySuccess = (data) => {
    return {
        type: EDIT_CORRESPONDENT_ENTITY_SUCCESS,
        data
    }
}
export const editCorrespondentEntityFailure = (data) => {
    return {
        type: EDIT_CORRESPONDENT_ENTITY_FAILURE,
        data
    }
}